import { ENDPOINTS } from 'config/endpoints';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import CronoError from 'crono-fe-common/types/error';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import { StrategySettingsPatch } from 'crono-fe-common/types/DTO/strategySettingsPatch';
import { useGetExtensionStatus } from '../crono-extension/useGetExtensionStatus';
import { createErrorIfExtensionIsNotFullyFunctional } from 'utils/businessLogic';

export default function usePatchStrategySettings() {
  const queryClient = useQueryClient();
  const { data: extensionStatus } = useGetExtensionStatus();

  const patchStrategySettings = (patch: StrategySettingsPatch) => {
    const request: Request = {
      url: `${ENDPOINTS.strategySettings.main}`,
      config: {
        method: 'patch',
        data: { data: patch },
      },
    };

    if (
      patch.selectedInsightsForRewrite &&
      patch.selectedInsightsForRewrite.length > 0
    ) {
      const errorResponse = createErrorIfExtensionIsNotFullyFunctional(
        extensionStatus?.status,
      );
      if (errorResponse) {
        return errorResponse;
      }
    }

    return client(request);
  };

  return useMutation<Response<null>, CronoError, StrategySettingsPatch>(
    patchStrategySettings,
    {
      onSettled: (result, error, variables) => {
        queryClient.invalidateQueries([
          ENDPOINTS.strategySettings.main,
          variables.strategyId,
        ]);
        queryClient.invalidateQueries([ENDPOINTS.strategy.search]);
        queryClient.invalidateQueries([
          ENDPOINTS.strategy.main,
          variables.strategyId,
        ]);
        queryClient.invalidateQueries([
          ENDPOINTS.strategy.details,
          variables.strategyId,
        ]);
      },
    },
  );
}
